<!--
 * @Author: wsx
 * @Date: 2022-03-05 11:10:11
 * @LastEditTime: 2022-03-05 17:35:19
 * @Description: 一标三实+N查询
 * @FilePath: \smart-community\src\views\smartApplication\threeSolidQuery\index.vue
-->
<template>
  <div class="threeSolidQuery">
    <div class="hz-map-box">
      <my-map></my-map>
    </div>
    <div class="threeSolidQuery-content">
      <h-frame type="left">
        <div class="frame-content">
          <el-input
            v-model="searchVal"
            placeholder="请输入搜索内容"
            class="input-with-select"
            size="large"
            style="width: 100%"
          >
            <template #prepend>
              <el-select
                v-model="currentType.id"
                placeholder="请选择"
                style="width: 110px"
              >
                <el-option
                  @click="clickType(item)"
                  v-for="item in typeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
                <!-- <template> </template> -->
              </el-select>
            </template>
            <template #append>
              <h-button @click="queryData" icon="icon-31sousuo"></h-button>
            </template>
          </el-input>
          <div class="search-results-tips">
            <!-- {{ `可视区域为您找到${currentType.value}${currentType.name}` }} -->
          </div>
          <component
            ref="dataListRef"
            class="data-list"
            :is="currentType.component"
            @clickPerson="personDetails"
            @clickHouse="houseDetails"
            @clickCar="carDetails"
            @populationlistData="populationlistData"
          ></component>
        </div>
      </h-frame>
      <div class="data-type">
        <ul class="data-type-content">
          <template v-for="item in typeList" :key="item.id">
            <li
              class="type-item"
              :class="{ current: currentType.id === item.id }"
              @click="clickType(item)"
            >
              <span>{{ item.name }}</span>
              <span class="value">{{ item.value }}</span>
            </li>
          </template>
        </ul>
      </div>
    </div>
    <!-- 搜索 -->
    <search
      v-model:equipemntType="mapNameLabel"
      :close="!labelLegendState"
      @emitRegionList="getRegionList"
    ></search>
  </div>
</template>
<script>
import { defineComponent, reactive, toRefs, ref, nextTick } from "vue";
import util from "@util/js";
import MyMap from "@/components/map/MyMap.vue";
import population from "./components/population.vue";
import house from "./components/house.vue";
import car from "./components/car.vue";
import power from "./components/power.vue";
import security from "./components/security.vue";
import policeSituation from "./components/policeSituation.vue";
import { getMenutree } from "@/api/system/region.js";
import { queryUserList } from "@/api/realPopulation/realPopulation.js";
import { eventqueryAssignEvent } from "@/api/eventManagement/eventManagementApi.js";
import {
  houseList,
  carlist,
  infoByPoint,
} from "@/api/threeSolid/fileManagement.js";
import {
  securitylist,
  equipmentlist,
  strengthlist,
} from "@/api/threeSolid/threeSolid.js";

export default defineComponent({
  name: "threeSolidQuery",
  components: {
    MyMap,
    population,
    house,
    car,
    power,
    security,
    policeSituation,
  },
  setup(props) {
    const data = reactive({
      prisonIds: 0,
      searchVal: "",
      address: "",
      arealist: [],
      houseList: [],
      areaOptions: [],
      populationlist: [],
      carlist: [],
      securitylist: [],
      equipmentlist: [],
      typeList: [
        {
          id: 1,
          name: "实有人口",
          component: "population",
          value: "0",
        },
        {
          id: 2,
          name: "实有房屋",
          component: "house",
          value: "0",
        },
        {
          id: 3,
          name: "实有车辆",
          component: "car",
          value: "0",
        },
        {
          id: 4,
          name: "力量装备",
          component: "power",
          value: "0",
        },
        {
          id: 5,
          name: "安防设施",
          component: "security",
          value: "0",
        },
        {
          id: 6,
          name: "警情事件",
          component: "policeSituation",
          value: "0",
        },
      ],
      currentType: {
        id: "",
      },
      regionIds: [],
    });
    const refData = toRefs(data);
    const dataListRef = ref();
    //区域选择
    const getRegionList = (val) => {
      data.regionIds = val;
      nextTick(() => {
        gethouseList();
        getpopulation();
      });
    };
    // 设置默认类型
    data.currentType = JSON.parse(JSON.stringify(data.typeList[0]));

    // 点击类型
    const clickType = (row) => {
      console.log(row);
      data.currentType = JSON.parse(JSON.stringify(row));
    };
    // 获取区域列表
    const infoSelectAxios = async () => {
      // const params = {
      //   type: 4
      // };
      const params = {
        type: -1,
      };
      const res = await getMenutree(params);
      const list = [];
      // res.list.forEach(item => {
      //   if (item.type === -1) {
      //     list.push(item);
      //   }
      // });
      console.log(list, 99999999999);
      // const rootPid = res.top.map(item => {
      //   return item.toString();
      // });
      const options = { pid: "regionId", id: "parentId", rootPid: 0 };
      const treeData = util.arrayToTree(list, options);
      data.areaOptions = treeData;
      // const res = await infoSelect();
      // data.areaOptions = [res.data];
    };
    // 获取具体区域
    const getinfoByPoint = async () => {
      const params = {
        x: 123,
        y: 123,
        type: 1,
      };
      const res = await infoByPoint(params);
      data.arealist = res;
      console.log(data.arealist);
    };
    // 获取房屋管理列表
    const gethouseList = async () => {
      const params = {
        page: 1,
        limit: 10000,
        regionIds: data.regionIds.toString(),
      };
      const res = await houseList(params);
      data.houseList = res.page.list;
      data.typeList.forEach((item) => {
        if (item.id === 2) {
          item.value = res.page.totalCount;
        }
      });
    };
    // 获取人口
    const getpopulation = async () => {
      const params = {
        page: 1,
        limit: 10000,
        regionIds: data.regionIds.toString(),
      };
      if (data.searchVal) {
        params.search = data.searchVal;
      } else {
        delete params.search;
      }
      const res = await queryUserList(params);
      data.populationlist = res.page.list;
      console.log("首页人口", data.populationlist);
      data.typeList.forEach((item) => {
        if (item.id === 1) {
          item.value = data.populationlist.length;
        }
      });
    };
    // 获取车辆
    const getcarlist = async () => {
      const params = {
        page: 1,
        limit: 10000,
      };
      const res = await carlist(params);
      data.carlist = res.page.list;
      console.log("首页车辆", data.carlist);
      data.typeList.forEach((item) => {
        if (item.id === 3) {
          item.value = res.page.totalCount;
        }
      });
    };
    // 获取安防设备
    const getsecuritylist = async () => {
      const params = {
        page: 1,
        limit: 10000,
      };
      const res = await securitylist(params);
      data.securitylist = res.page.list;
      console.log("首页安防", securitylist);
      data.typeList.forEach((item) => {
        if (item.id === 5) {
          item.value = res.page.totalCount;
        }
      });
    };
    // 获取装备
    const getequipmentlist = async () => {
      const params = {
        page: 1,
        limit: 10000,
      };
      const res = await equipmentlist(params);
      const ress = await strengthlist(params);
      data.equipmentlist = res.page.list;
      data.typeList.forEach((item) => {
        if (item.id === 4) {
          item.value = ress.page.totalCount + "/" + res.page.totalCount;
        }
      });
    };
    // 获取事件
    const eventqueryAssignEventaxios = async () => {
      const params = {
        page: 1,
        limit: 10000,
      };
      const res = await eventqueryAssignEvent(params);
      data.equipmentlist = res.page.list;
      data.typeList.forEach((item) => {
        if (item.id === 6) {
          item.value = res.page.totalCount;
        }
      });
    };

    infoSelectAxios();
    getinfoByPoint();
    gethouseList();
    getpopulation();
    getcarlist();
    getsecuritylist();
    getequipmentlist();
    eventqueryAssignEventaxios();
    // 详细地址的判断
    const cascaderchange = (val) => {
      console.log(
        "%c [ val ]-174",
        "font-size:13px; background:pink; color:#bf2c9f;",
        val
      );
    };
    // 请求数据
    const queryData = async () => {
      data.currentType.value = await dataListRef.value.queryData(
        data.searchVal
      );
    };
    // 人员详情
    const personDetails = (row) => {
      console.log("查看人员详情", row);
    };
    // 房屋详情
    const houseDetails = (row) => {
      console.log("查看房屋详情", row);
    };
    // 车辆详情
    const carDetails = (row) => {
      console.log("查看车辆详情", row);
    };

    return {
      ...refData,
      personDetails,
      dataListRef,
      houseDetails,
      carDetails,
      clickType,
      cascaderchange,
      queryData,
      gethouseList,
      getpopulation,
      getcarlist,
      getsecuritylist,
      getequipmentlist,
      getRegionList,
    };
  },
});
</script>
<style lang="scss" scoped>
.threeSolidQuery {
  position: relative;
  color: #fff;
  .hz-map-box {
    width: 100%;
    height: 100%;
  }
  .threeSolidQuery-content {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    .data-type {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
      width: 100%;
      @include flex-row-c-c;
      .data-type-content {
        pointer-events: auto;
        margin-top: 20px;
        @include flex-row-c-c;
        .type-item {
          background-image: url("~@/assets/images/home/house.png");
          background-size: 100% 100%;
          width: 146px;
          height: 74px;
          margin: 0 10px;
          color: #fff;
          box-sizing: border-box;
          padding: 10px 0;
          font-size: 16px;
          cursor: pointer;
          @include flex-col-se-c;
          &.current {
            color: #25f9ed;
          }
        }
      }
    }
    .frame-content {
      width: 100%;
      height: 100%;
      overflow: hidden;
      padding: 20px 10px;
      box-sizing: border-box;
      @include flex-col-s-s;
      :deep(.el-input-group__prepend) {
        background-color: transparent;
        color: #fff;
        font-size: 16px;
      }
      :deep(.el-input-group__append) {
        background-color: transparent;
        color: #fff;
        font-size: 16px;
      }
      :deep(.el-input__inner) {
        background-color: transparent !important;
        color: #fff;
        font-size: 16px;
      }
      .search-results-tips {
        width: 100%;
        border-bottom: 1px solid #aab2c5;
        line-height: 48px;
        text-align: center;
        font-size: 16px;
        margin-bottom: 5px;
      }
      .data-list {
        width: 100%;
        flex: 1;
        overflow: hidden;
        color: #fff;
      }
    }
    .address-box {
      position: absolute;
      right: 20px;
      top: 20px;
      padding: 20px;
      z-index: 3;
      border-radius: 10px;
      pointer-events: auto;
      background-color: rgba($color: #000000, $alpha: 0.6);
    }
  }
}
</style>
